import { Link } from '@mui/material';
import type { LinkProps } from '@mui/material';
import { LocalizedLink as GatsbyLocalizedLink, useLocalization } from 'gatsby-theme-i18n';

export function LocalizedLink({ children, href, ...props }: LinkProps): React.ReactElement {
  const { locale } = useLocalization();
  return (
    <Link component={GatsbyLocalizedLink} language={locale} to={href} {...props}>
      {children}
    </Link>
  );
}
